import config from 'configDir/index';
import { get } from './http';

const baseUrl = '/practitioner';

//  查询车辆驾驶员
const queryDriverByUniqueLicence = get(`${baseUrl}/queryDriverByUniqueLicence`, config.resourceUrl);

//  查询车辆从业人员
const queryPractitionerByUniqueLicence = get(
  `${baseUrl}/queryPractitionerByUniqueLicence`,
  config.resourceUrl,
);

// 查询从业人员
const queryPractitionerService = get(`${baseUrl}/queryPractitioner`, config.resourceUrl);

export {
  // eslint-disable-next-line import/prefer-default-export
  queryDriverByUniqueLicence,
  queryPractitionerByUniqueLicence,
  queryPractitionerService,
};
